import AOS from 'aos';
$(function() {
    AOS.init({duration: 800});
});